import React, { useState, useEffect } from "react";
import { Link } from "react-router-dom";
// nodejs library that concatenates classes
import API from "../../utils/api";
import { manufacturerLogoUrl } from "config/images.js";
import classNames from "classnames";
// @material-ui/core components
import { makeStyles } from "@material-ui/core/styles";
import { withStyles } from "@material-ui/core/styles";
// @material-ui/icons
import green from "@material-ui/core/colors/green";
import red from "@material-ui/core/colors/red";
import brown from "@material-ui/core/colors/brown";
import Table from "@material-ui/core/Table";
import TableBody from "@material-ui/core/TableBody";
import TableCell from "@material-ui/core/TableCell";
import TableHead from "@material-ui/core/TableHead";
import TableRow from "@material-ui/core/TableRow";
import LinearProgress from "@material-ui/core/LinearProgress";
import Typography from "@material-ui/core/Typography";
import CheckCircleOutlineIcon from "@material-ui/icons/CheckCircleOutline";
import BlockIcon from "@material-ui/icons/Block";
import HelpOutlineIcon from "@material-ui/icons/HelpOutline";
import Tooltip from "@material-ui/core/Tooltip";
import SearchIcon from "@material-ui/icons/Search";
import IconButton from "@material-ui/core/IconButton";
import TextField from "@material-ui/core/TextField";
import InputAdornment from "@material-ui/core/InputAdornment";
import Card from "@material-ui/core/Card";
import CardContent from "@material-ui/core/CardContent";
import Divider from "@material-ui/core/Divider";
import Box from "@material-ui/core/Box";

// core components
import Header from "components/Header/Header.js";
import Footer from "components/Footer/Footer.js";
import GridContainer from "components/Grid/GridContainer.js";
import GridItem from "components/Grid/GridItem.js";
import HeaderLinks from "components/Header/HeaderLinks.js";
import Parallax from "components/Parallax/Parallax.js";

import profile from "assets/img/ultragreen-logo-big.png";

import styles from "assets/jss/material-kit-react/views/SearchPageStyle.js";
import { fetchCertTypes } from "utils/ugcCertTypes";
import CertString from "components/UltraGreenCert/CertString";

const useStyles = makeStyles(styles);

const TableCellCustom = withStyles((theme) => ({
  head: {
    backgroundColor: "#38c754",
    color: theme.palette.common.white,
  },
  body: {},
}))(TableCell);

const CheckCircleOutlineIconGreen = withStyles({
  root: {
    color: green[400],
  },
})((props) => (
  <Tooltip
    title="Approved by UltraGreen Certification standard!"
    placement="right-start"
  >
    <CheckCircleOutlineIcon color="default" {...props} />
  </Tooltip>
));

const BlockIconRed = withStyles({
  root: {
    color: red[400],
  },
})((props) => (
  <Tooltip
    title="Prohibited by UltraGreen Certification standard!"
    placement="right-start"
  >
    <BlockIcon color="default" {...props} />
  </Tooltip>
));

const HelpOutlineIconBrown = withStyles({
  root: {
    color: brown[200],
  },
})((props) => (
  <Tooltip title="Custom classification needed!" placement="right-start">
    <HelpOutlineIcon color="default" {...props} />
  </Tooltip>
));

export default function SearchPage(props) {
  const classes = useStyles();
  const { ...rest } = props;
  const params = new URLSearchParams(window.location.search);
  const urlquery = params.get("urlquery");

  const imageClasses = classNames(
    classes.imgRaised,
    classes.imgRoundedCircle,
    classes.imgFluid,
  );
  const [state, setState] = useState({
    pageNum: "0",
    loading: false,
    searchResult: [],
    resultSizeIngSub: 0,
    resultSizeBrands: 0,
    searchText: "",
    resultInfoText: "Start searching!",
  });
  const [count, setCount] = useState(0);
  const [isMobile, setIsMobile] = useState(window.innerWidth <= 600);

  const [stateQuery, setStateQuery] = useState("");
  const [certTypes, setCertTypes] = useState([]);

  useEffect(() => {
    let live = true;
    fetchCertTypes().then((types) => {
      if (live) setCertTypes(types);
    });
    return () => {
      live = false;
    };
  }, []);

  useEffect(() => {
    const handleResize = () => {
      setIsMobile(window.innerWidth <= 600);
    };
    window.addEventListener("resize", handleResize);
    return () => window.removeEventListener("resize", handleResize);
  }, []);

  const handleChangeText = (event) => {
    setState({ ...state, [event.target.id]: event.target.value });
  };

  const onKeyUp = (event) => {
    if (event.charCode === 13) {
      startSearching();
    }
  };

  const handleClickSearch = (event) => {
    startSearching();
  };

  function startSearching() {
    const query = state.searchText;
    setState({ loading: true });
    setStateQuery(query);
  }

  useEffect(() => {
    // See SearchSection.js: this was gated on a /ultragreen/hb ping whose
    // endpoint no longer exists, so ?urlquery= never reached the search.
    if (urlquery) {
      setStateQuery(urlquery);
    }
  }, []);

  useEffect(() => {
    const query = stateQuery;
    setCount(count + 1);
    console.log(count);
    if (query === "" || query === undefined || query === null || count === 0) {
      setState({
        loading: false,
        searchResult: [],
        resultSizeIngSub: 0,
        resultSizeBrands: 0,
        searchText: "",
        resultInfoText: "Start searching!",
      });
      return;
    }
    if (query.length < 4 && query.length > 0) {
      setState({
        resultInfoText: "Please type longer search query!",
      });
      return;
    }
    API.get("search/all/" + stateQuery + "/" + "0" + "/50/cosahh.com")
      .then(function(response) {
        var allRepos = response.data;
        var ingSubList = response.data.resultIngSubs;
        var brandsList = response.data.resultBrands;
        const sizeIngSub = ingSubList.length;
        const sizeBrands = brandsList.length;
        setState({
          loading: false,
          searchResult: allRepos,
          resultSizeIngSub: sizeIngSub,
          resultSizeBrands: sizeBrands,
          searchText: "",
          resultInfoText: "",
        });

        if (sizeIngSub === 0 && sizeBrands === 0) {
          setState({
            resultInfoText: "No results.",
          });
        }

        console.log(response);
        console.log("Size ingsub: " + sizeIngSub);
        console.log("Size brands: " + sizeBrands);
      })
      .catch(function(error) {});
  }, [stateQuery]);

  // Mobile Card Component for Ingredients
  const IngredientCard = ({ ingredient }) => (
    <Card style={{ marginBottom: "16px" }}>
      <CardContent>
        <Typography variant="h6" gutterBottom>
          <a
            style={{ color: "#38c754", textDecoration: "none" }}
            href={"https://www.skinlyzer.com/ingredient/" + ingredient.authId}
            target="_blank"
            rel="noopener noreferrer"
          >
            {ingredient.inci}
          </a>
        </Typography>
        <Divider style={{ margin: "12px 0" }} />
        <Box mb={1}>
          <Typography variant="body2" color="textSecondary">
            <strong>CAS:</strong> {ingredient.cas}
          </Typography>
        </Box>
        <Box mb={1}>
          <Typography variant="body2" color="textSecondary">
            <strong>EC:</strong> {ingredient.ec}
          </Typography>
        </Box>
        <Box mb={1} display="flex" alignItems="center">
          <Typography
            variant="body2"
            color="textSecondary"
            style={{ marginRight: "8px" }}
          >
            <strong>Cosmetic Status:</strong>
          </Typography>
          {ingredient.ultraGreenScore === 0 &&
            ingredient.ultraGreenScore !== undefined && (
              <HelpOutlineIconBrown />
            )}
          {ingredient.ultraGreenScore === 1 && <CheckCircleOutlineIconGreen />}
          {ingredient.ultraGreenScore === 2 && <BlockIconRed />}
        </Box>
        <Box display="flex" alignItems="center">
          <Typography
            variant="body2"
            color="textSecondary"
            style={{ marginRight: "8px" }}
          >
            <strong>Detergent Status:</strong>
          </Typography>
          {ingredient.ultraGreenScoreDetergent === 0 &&
            ingredient.ultraGreenScoreDetergent !== undefined && (
              <HelpOutlineIconBrown />
            )}
          {ingredient.ultraGreenScoreDetergent === 1 && (
            <CheckCircleOutlineIconGreen />
          )}
          {ingredient.ultraGreenScoreDetergent === 2 && <BlockIconRed />}
        </Box>
      </CardContent>
    </Card>
  );

  // Mobile Card Component for Brands
  const BrandCard = ({ brand }) => {
    return (
      <Card style={{ marginBottom: "16px" }}>
        <CardContent>
          <Box display="flex" alignItems="center" mb={2}>
            <img
              src={
                manufacturerLogoUrl(brand.logoUrl)
              }
              width="80"
              alt={brand.name}
              style={{ marginRight: "12px" }}
            />
            <Typography variant="h6">
              <Link
                to={"/brand/" + encodeURIComponent(brand.authId)}
                style={{ color: "#38c754", textDecoration: "none" }}
              >
                {brand.name}
              </Link>
            </Typography>
          </Box>
          <Divider style={{ margin: "12px 0" }} />
          <Box mb={2}>
            <Typography variant="body2" color="textSecondary">
              <strong>Description:</strong>
              <br />
              [HU] {brand.description}
            </Typography>
          </Box>
          <Box>
            <Typography variant="body2" color="textSecondary">
              <strong>Certification Status:</strong>
            </Typography>
            <Box mt={1}>
              <CertString brand={brand} types={certTypes} />
            </Box>
          </Box>
        </CardContent>
      </Card>
    );
  };

  const ingsubElements =
    state.loading === false && state.searchResult.resultIngSubs !== undefined
      ? state.searchResult.resultIngSubs.map((n) => {
          return (
            <TableRow key={n.id} className={classes.row}>
              <TableCell component="th" scope="row" className={classes.cell}>
                <a
                  style={{ color: "#555" }}
                  href={"https://www.skinlyzer.com/ingredient/" + n.authId}
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  {n.inci}
                </a>
              </TableCell>
              <TableCell className={classes.cell}>{n.cas}</TableCell>
              <TableCell className={classes.cell}>{n.ec}</TableCell>
              <TableCell className={classes.cellHead}>
                {n.ultraGreenScore === 0 && n.ultraGreenScore !== undefined && (
                  <HelpOutlineIconBrown />
                )}
                {n.ultraGreenScore === 1 && <CheckCircleOutlineIconGreen />}
                {n.ultraGreenScore === 2 && <BlockIconRed />}
              </TableCell>
              <TableCell className={classes.cellHead}>
                {n.ultraGreenScoreDetergent === 0 &&
                  n.ultraGreenScoreDetergent !== undefined && (
                    <HelpOutlineIconBrown />
                  )}
                {n.ultraGreenScoreDetergent === 1 && (
                  <CheckCircleOutlineIconGreen />
                )}
                {n.ultraGreenScoreDetergent === 2 && <BlockIconRed />}
              </TableCell>
            </TableRow>
          );
        })
      : "";

  const brandsElements =
    state.loading === false && state.searchResult.resultBrands !== undefined
      ? state.searchResult.resultBrands.map((b) => {
          return (
            <TableRow key={b.id} className={classes.row}>
              <TableCell className={classes.cell}>
                <img
                  src={
                    manufacturerLogoUrl(b.logoUrl)
                  }
                  width="100"
                  alt={b.name}
                />
                <Link
                  to={"/brand/" + encodeURIComponent(b.authId)}
                >
                  &nbsp;{b.name}
                </Link>
              </TableCell>
              <TableCell component="th" scope="row" className={classes.cell}>
                [HU] {b.description}
              </TableCell>
              <TableCell className={classes.cell} className={classes.cellHead}>
                <CertString brand={b} types={certTypes} />
              </TableCell>
            </TableRow>
          );
        })
      : "";

  return (
    <div>
      <Header
        color="transparent"
        brand="UltraGreen Database"
        rightLinks={<HeaderLinks />}
        fixed
        changeColorOnScroll={{
          height: 200,
          color: "white",
        }}
        {...rest}
      />
      <Parallax small filter image={require("assets/img/bg-granules.jpg")} />
      <div className={classNames(classes.main)}>
        <div className={classes.container}>
          <GridContainer justify="center">
            <GridItem xs={12} sm={12} md={8}>
              <div className={classes.profile}>
                <div>
                  <img src={profile} alt="..." className={imageClasses} />
                </div>
                <div className={classes.name}>
                  <div className={classes.typo}>
                    <h2 className={classes.title}>
                      UltraGreen Certification Database
                    </h2>
                  </div>
                  <div className={classes.typo}>
                    <p className={classes.description}>
                      You can search cosmetic and detergent ingredients, which
                      can be or not used in UltraGreen Certified products, and
                      also you can find your favourite brands certification
                      status.
                    </p>
                  </div>
                </div>
              </div>
            </GridItem>
          </GridContainer>
          <GridContainer justify="center">
            <GridItem xs={12} sm={12} md={12}>
              <div style={{ paddingBottom: 50 }}>
                <TextField
                  id="searchText"
                  label="Search brands, ingredients e.g. Benzyl Alcohol or by cas, ec numbers."
                  onChange={handleChangeText}
                  value={state.searchText}
                  onKeyPress={onKeyUp}
                  fullWidth
                  margin="normal"
                  InputProps={{
                    endAdornment: (
                      <InputAdornment position="end">
                        <IconButton
                          onClick={handleClickSearch}
                          className={classes.iconButton}
                          aria-label="search"
                        >
                          <SearchIcon />
                        </IconButton>
                      </InputAdornment>
                    ),
                  }}
                />
              </div>
            </GridItem>
            <GridItem xs={12} sm={12} md={12}>
              {state.resultSizeBrands > 0 && (
                <div>
                  <Typography variant="h5" className={classes.subTitle}>
                    Brands
                  </Typography>

                  {/* Desktop Table */}
                  {!isMobile && (
                    <Table className={classes.table}>
                      <TableHead className={classes.tableHead}>
                        <TableRow>
                          <TableCellCustom style={{ width: "30%" }}>
                            Brand Name
                          </TableCellCustom>
                          <TableCellCustom style={{ width: "50%" }}>
                            Description
                          </TableCellCustom>
                          <TableCellCustom className={classes.cellHead}>
                            Certification Status
                          </TableCellCustom>
                        </TableRow>
                      </TableHead>
                      <TableBody>{brandsElements}</TableBody>
                    </Table>
                  )}

                  {/* Mobile Cards */}
                  {isMobile && state.searchResult.resultBrands && (
                    <div>
                      {state.searchResult.resultBrands.map((brand) => (
                        <BrandCard key={brand.id} brand={brand} />
                      ))}
                    </div>
                  )}

                  <Typography
                    variant="h5"
                    className={classes.subTitle2}
                  ></Typography>
                </div>
              )}
              {state.resultSizeIngSub > 0 && (
                <div>
                  <Typography variant="h5" className={classes.subTitle}>
                    Ingredients
                  </Typography>

                  {/* Desktop Table */}
                  {!isMobile && (
                    <Table className={classes.table}>
                      <TableHead className={classes.tableHead}>
                        <TableRow>
                          <TableCellCustom style={{ width: "50%" }}>
                            INCI
                          </TableCellCustom>
                          <TableCellCustom>CAS</TableCellCustom>
                          <TableCellCustom>EC</TableCellCustom>
                          <TableCellCustom className={classes.cellHead}>
                            Cosmetic Status
                          </TableCellCustom>
                          <TableCellCustom className={classes.cellHead}>
                            Detergent Status
                          </TableCellCustom>
                        </TableRow>
                      </TableHead>
                      <TableBody>{ingsubElements}</TableBody>
                    </Table>
                  )}

                  {/* Mobile Cards */}
                  {isMobile && state.searchResult.resultIngSubs && (
                    <div>
                      {state.searchResult.resultIngSubs.map((ingredient) => (
                        <IngredientCard
                          key={ingredient.id}
                          ingredient={ingredient}
                        />
                      ))}
                    </div>
                  )}
                </div>
              )}
              {(state.resultSizeIngSub > 0 || state.resultSizeBrands > 0) && (
                <div style={{ paddingTop: 20 }}>
                  <Typography variant="caption" display="block" gutterBottom>
                    You should more specific the ingredient name if you don't
                    get the expected result.
                  </Typography>
                </div>
              )}
              {state.loading && <LinearProgress />}
            </GridItem>
          </GridContainer>
          <div style={{ paddingTop: 20, paddingBottom: 50 }}>
            <Typography align="center" variant="body1" gutterBottom>
              {state.resultInfoText}
            </Typography>
          </div>
          <div style={{ paddingTop: 50, paddingBottom: 50 }}>
            <Typography variant="body1" gutterBottom>
            </Typography>
            <Typography variant="caption" display="block" gutterBottom>
              Please note that ingredient assigned with an INCI name that
              appears in the results section of this page does not mean it is to
              be used in cosmetic products nor approved for such use.
            </Typography>
            <Typography variant="caption" display="block" gutterBottom>
              In addition, the use of any ingredient in cosmetic products must
              be supported by a safety assessment of the product.
            </Typography>
          </div>
        </div>
      </div>
      <Footer />
    </div>
  );
}
